// Copyright (c) 2016 Deere & Company

export const isDemoRentalReqCriteriaValid = (dealers, status) => dealers.length > 0 && status.trim().length > 0;



// WEBPACK FOOTER //
// ./src/reports/shared/services/criteria-validation.js